
export const defaultLocale = 'en';
export const googleMapApiKey = 'AIzaSyD-UcjfAoWQ50RH1_ZNckdkr6DZTcHStOQ';
export const localeOptions=[
    { id:'en',name:'English',icon:'flag-icon-us' },
    { id:'es',name:'Español',icon:'flag-icon-es' },
];
export const SectionUnavailable = 'This section is unavailable. You may not have the required account permissions or an active module subscription to access it.';
